import { Button } from '@gitbook/spine-react';
import { assertNever } from '@gitbook/util-ts';

import { ContentIcon } from '../../../Components';

export type AIProvider = 'claude' | 'cursor' | 'codex';

const AI_PROVIDER_PLUGIN_URLS: Record<AIProvider, string> = {
    claude: 'https://claude.ai/directory/connectors/gitbook-mcp',
    cursor: 'https://cursor.com/marketplace/gitbook',
    codex: 'https://chatgpt.com/apps/gitbook/asdk_app_6a576f075ec4819196c203b7049542be',
};

/**
 * Open the GitBook plugin/connector listing for an AI provider, so the user can install it.
 */
export function AIProviderLaunchButton(props: {
    provider: AIProvider;
    onLaunch?: (provider: AIProvider) => void;
}) {
    const { provider, onLaunch } = props;
    const providerProps = getAIProviderProps(provider);
    const { label, icon } = providerProps;

    return (
        <Button
            kind="secondary"
            size="medium"
            label={label}
            tooltip={{ label: `Install the GitBook plugin for ${label}` }}
            leadingIcon={icon}
            onPress={() => {
                window.open(AI_PROVIDER_PLUGIN_URLS[provider], '_blank', 'noopener,noreferrer');
                onLaunch?.(provider);
            }}
            className="flex-1"
        />
    );
}

function getAIProviderProps(provider: AIProvider) {
    switch (provider) {
        case 'claude':
            return {
                label: 'Claude Code',
                icon: <ContentIcon icon="claude" />,
            };
        case 'cursor':
            return {
                label: 'Cursor',
                icon: <ContentIcon icon="cursor" />,
            };
        case 'codex':
            return {
                label: 'Codex',
                icon: <ContentIcon icon="openai" />,
            };
        default:
            assertNever(provider);
    }
}
